import { isIwocaDE } from '@src/utils/countryHelper';

import {
    handleError,
    handleFatalError,
    waitForErrorToLogThenRedirectToLogin
} from './Api';
import { getIsLoggedInCookie } from './Cookies';
import { redirectToURL } from '../helpers/redirection';

export function isSuccessful(httpStatusCode) {
    return httpStatusCode >= 200 && httpStatusCode < 300;
}

function isRedirect(httpStatusCode, type) {
    return (
        httpStatusCode === 302 ||
        (httpStatusCode === 0 && type === 'opaqueredirect')
    );
}

export function isAuthenticationError(httpStatusCode) {
    return httpStatusCode === 401 || httpStatusCode === 403;
}

export function isClientError(httpStatusCode) {
    return (
        httpStatusCode >= 400 &&
        httpStatusCode < 500 &&
        !isAuthenticationError(httpStatusCode)
    );
}

export function isServerError(httpStatusCode) {
    return httpStatusCode >= 500;
}

export function handleResponseStatus(response) {
    if (isSuccessful(response.status)) {
        return response;
    } else if (isRedirect(response.status, response.type)) {
        redirectToURL(response.url);
    } else if (isAuthenticationError(response.status)) {
        const currentPath = window.location.pathname;
        const isDE = isIwocaDE();
        const isLoggedIn = getIsLoggedInCookie();
        const applyNowUKPath = '/account/signup/apply-now/';

        if (!isLoggedIn && !isDE) {
            if (currentPath === applyNowUKPath) return;
            redirectToURL(applyNowUKPath);
        } else {
            waitForErrorToLogThenRedirectToLogin(response);
        }
    } else if (isClientError(response.status)) {
        handleError(response);
    } else if (isServerError(response.status)) {
        handleFatalError(response);
    }

    const error = new Error(response.statusText);
    error.response = response;
    throw error;
}
